const U = (id) => `https://images.unsplash.com/${id}?auto=format&fit=crop&w=900&q=80`;
const P = (id) => `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&w=900`;

export const PRODUCTS = [
  {
    id: 1,
    name: "Utókezelő krém",
    desc: "Könnyű, gyorsan beszívódó krém a friss tetoválás mindennapi ápolásához — nyugtat és hidratál.",
    img: U("photo-1598440947619-2c35fc9aa908"),
  },
  {
    id: 2,
    name: "Regeneráló olaj",
    desc: "Természetes összetevők a bőr nyugtatására és a színek védelmére a gyógyulási időszakban.",
    img: P(7795810),
  },
  {
    id: 3,
    name: "Utókezelő kenőcs",
    desc: "Intenzív hidratáló és védő kenőcs tetoválás és piercing utánra — a stúdióban is ezt használjuk.",
    img: U("photo-1615397349754-cfa2066a298e"),
  },
];

export const PAINTINGS = [
  { id: 1, title: "01. Kortárs festmény", status: "shown", img: P(1616403) },
  { id: 2, title: "02. Kortárs festmény", status: "wip" },
  { id: 3, title: "03. Kortárs festmény", status: "wip" },
];
